module.exports = __webpack_public_path__ + "img/skills-summon-nec-3.0dacd5cf.png";